var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 24,
    viewBox: "0 0 66 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.1701 12.8616C65.1701 12.8616 60.3675 19.1659 53.0369 19.8978C45.586 20.6417 35.6041 15.8273 36.9534 8.47564C37.6792 4.52094 40.0043 1.98939 44.0213 2.29072C48.0248 2.59104 50.4158 5.48388 50.9357 9.45748C52.0488 17.9649 40.8252 23.6592 32.2497 23.0729C23.6569 22.4854 13.0898 15.2411 15.4098 6.96285C16.4949 3.09106 19.1894 0.429537 23.1979 0.828492C27.127 1.21955 29.6648 4.07938 30.1123 7.99525C31.0668 16.3498 20.3387 23.021 12.0264 21.6528C6.5989 20.7594 3.08468 17.9261 1.06806 12.8176",
    stroke: "#9199A8",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.10d9b712163addd82a12810ab252ce86.svg";
export { ForwardRef as ReactComponent };